/**
 * Heads-up below the Pause and Close buttons (listing-marketing-hub BR-15a): shown while the listing has posted
 * records, so the landlord knows pausing or closing leaves those posts up.
 */
import { Info } from 'lucide-react';
import type { ExternalListingPostDto } from '../../lib/external-listing-posts.api';
import { postedPosts, siteNames } from '../../lib/listing-marketing';

export function PostsHeadsUp({ posts }: { posts: ExternalListingPostDto[] | undefined }) {
  const posted = postedPosts(posts);
  if (posted.length === 0) return null;
  const n = posted.length;
  return (
    <p className="flex items-start gap-2 text-sm text-muted-foreground" data-testid="listing-posts-heads-up">
      <Info aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-info" />
      Pausing or closing does not take down your {n === 1 ? 'post' : `${n} posts`} on {siteNames(posted)}.
    </p>
  );
}
